import GIDResolver from './GIDResolver'
import NativeResolver from './NativeResolver'

function ResolveImportFile(content) {
  const nativeResolver = new NativeResolver(content)
  let importPayload = nativeResolver.resolve()
  if (!importPayload) {
    const gidResolver = new GIDResolver(content)
    importPayload = gidResolver.resolve()
  }

  return importPayload
}

export default ResolveImportFile
